export default __webpack_public_path__ + "static/media/check-circle-regular.51acd49f.svg";